import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '渝超传情——探寻巴渝体育文化新韵';
const baseUrl = '20251031YUCHAO';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/home.vue'),
      meta: {
        title: PAGE_TITLE,
        showFooter: true,
      },
    },
    {
      path: 'emoji',
      name: `${baseUrl}-emoji`,
      component: () => import('./pages/emoji.vue'),
      meta: {
        title: PAGE_TITLE,
        showFooter: true,
      },
    },
    {
      path: 'music',
      name: `${baseUrl}-music`,
      component: () => import('./pages/music.vue'),
      meta: {
        title: PAGE_TITLE,
        showFooter: true,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/news.vue'),
      meta: {
        title: PAGE_TITLE,
        showFooter: true,
      },
    },
    {
      path: 'audioDetail',
      name: `${baseUrl}-audioDetail`,
      component: () => import('./pages/audioDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        showFooter: false,
      },
    },
    {
      path: 'emojiDetail',
      name: `${baseUrl}-emojiDetail`,
      component: () => import('./pages/emojiDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        showFooter: false,
      },
    },
    {
      path: 'ipDetail',
      name: `${baseUrl}-ipDetail`,
      component: () => import('./pages/ipDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        showFooter: false,
      },
    },
  ],
};

export default route;
